<template>
  <div>
    <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
      <v-tab> لیست دروس </v-tab>
      <v-tab> درخواست های قبلی </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div
          class="courses"
          :style="[details.length == 0 ? { 'padding-bottom': '0' } : '']"
        >
          <div class="notFound" v-if="details.length == 0">درسی وجود ندارد</div>
          <v-card v-else v-for="(item, key) in details" :key="key">
            <v-card-title class="info-detail">
              <div class="text-center">
                {{ item.N_Title }}
              </div>
            </v-card-title>
            <app-row icon="file-excel" title="کد درس: " :value="item.C_Title" />
            <app-row icon="hashtag" title="نمره: " :value="item.Mark" />
            <app-row
              v-if="item.State != ''"
              icon=""
              title=""
              :value="item.State"
            />
            <app-row
              v-else-if="!cycle.CanObject"
              icon=""
              title=""
              value="امکان اعتراض در این بازه زمانی وجود ندارد."
            />
            <v-row v-else class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('showDialog', item)"
              >
                درخواست تجدید نظر
              </v-btn>
            </v-row>
          </v-card>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div
          class="courses"
          :style="[eteraz.length == 0 ? { 'padding-bottom': '0' } : '']"
        >
          <div class="notFound" v-if="eteraz.length == 0">
            اعتراضی ثبت نشده است.
          </div>
          <v-card
            v-else
            v-for="key in eteraz.length"
            :key="key"
            :index="key - 1"
            @click="toggleExpansion(key - 1)"
          >
            <v-card-title class="info-detail">
              <font-awesome-icon
                class="collapse"
                :icon="getCourseIcon(key - 1)"
              />
              <div class="text-center text-padding">
                {{ eteraz[key - 1].N_Title }}
              </div>
            </v-card-title>
            <div>
              <app-row
                icon="file-excel"
                title="نمره قبلی: "
                :value="eteraz[key - 1].Mark"
              />
              <app-row
                icon="file-excel"
                title="نمره جدید: "
                :value="eteraz[key - 1].NewMark"
              />
              <app-row
                icon="question-circle"
                title="وضعیت: "
                :value="eteraz[key - 1].Pasokh"
              />
              <div v-if="selectedVahed == key - 1">
                <app-row
                  icon="calendar-alt"
                  title="تاریخ درخواست:"
                  :value="eteraz[key - 1].D_DateSabtEteraz"
                />
                <app-row
                  icon="calendar-alt"
                  title="تاريخ پاسخ:"
                  :value="eteraz[key - 1].D_DateSabtPasokh"
                />
              </div>
            </div>
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  data() {
    return {
      tab: null,
      items: ["دروس کسری", "دروس انتخاب شده"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    };
  },
  props: ["cycle", "selectedVahed", "details", "eteraz"],
  components: {
    appRow: DetailRow,
  },
  computed: {},

  methods: {
    getCourseIcon(index) {
      return this.selectedVahed == index ? "angle-down" : "angle-left";
    },
    toggleExpansion(key) {
      this.$emit("clickedVahed", key);
    },
    getState(item) {
      if (item.Srl_Eteraz != "") return "درخواست هم اکنون ثبت شده است.";
      else if (
        item.Mark <= this.cycle.EterazMax &&
        item.Mark >= this.cycle.EterazMin
      )
        return "";
      else return "امکان اعتراض وجود ندارد.";
    },
  },
};
</script>
<style scoped>
.notFound {
  background-color: white;
  padding: 20px;
}
.courses {
  background-color: white !important;
}


</style>
